import { useDispatch, useSelector } from 'react-redux';
import { getUserCategories, addUserCategory, removeUserCategory } from 'store/categories/actions';
import { getVersion } from 'store/version/actions';
import { resetItemsCategories } from 'store/items-categories/actions';
import { useEffect, useState } from 'react';
import {
  getUserCategories as getUserCategoriesSelector,
  getUserCategoriesLoadingState as getUserCategoriesLoadingStateSelector,
} from 'store/categories/selectors';
import { getUser as getUserSelector } from 'store/users/selectors';
import { getVersion as getVersionSelector } from 'store/version/selectors';
import {
  Link,
  Redirect, Route, Switch, useLocation,
} from 'react-router-dom';
import Info from './info';
import MembershipType from './membership-type';
import Categories from './categories';
import About from './about';
import { Container, TabMenuContainer } from './styles';
import withNavigationFilters from '../../../library/hocs/with-navigation-filters';
import { logout } from '../../../library/auth';
import ROUTES from '../../../library/constants/routes';
import { TermsAndConditions } from './terms-and-conditions';
import { PrivacyPolicy } from './privacy-policy';

const TAB_KEYS = {
  GENERAL: 'general',
  CATEGORIES: 'categories',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS: 'terms-and-conditions',
};

const TAB_KEYS_LABELS = {
  [TAB_KEYS.GENERAL]: 'General',
  [TAB_KEYS.CATEGORIES]: 'Categories',
  [TAB_KEYS.PRIVACY_POLICY]: 'Privacy policy',
  [TAB_KEYS.TERMS]: 'Terms and conditions',
};

function Settings(props) {
  const dispatch = useDispatch();
  const userCategories = useSelector(getUserCategoriesSelector);
  const userCategoriesLoading = useSelector(getUserCategoriesLoadingStateSelector);
  const user = useSelector(getUserSelector);
  const version = useSelector(getVersionSelector);
  const [localCategories, setLocalCategories] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(getUserCategories());
    dispatch(getVersion());

    return () => {
      dispatch(resetItemsCategories());
    };
  }, []);

  useEffect(() => {
    if (!userCategoriesLoading) {
      setLocalCategories(userCategories.filter(({ active }) => active).map(({ id }) => id));
    }
  }, [userCategoriesLoading]);

  const handleLogout = () => logout(props.history);

  const handleCategoryChange = (id, checked) => {
    const { name } = userCategories.find((category) => id === category.id);
    const newValue = [
      ...(
        checked ? [...localCategories, id] : localCategories.filter((item) => item !== id)
      ),
    ];

    setLocalCategories(newValue);

    if (checked) {
      dispatch(addUserCategory({ id, name }));
    } else {
      dispatch(removeUserCategory({ id, name }));
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div>
      <TabMenuContainer>
        <div style={{
          display: 'flex',
          gap: '12px',
          spacing: '4px',
          padding: '0 32px',
          width: '860px',
        }}
        >
          {Object.values(TAB_KEYS).map((tab) => (
            <Link
              key={tab}
              style={{
                fontSize: '14px',
                lineHeight: '16px',
                padding: '12px 8px',
                borderBottomWidth: '2px',
                borderBottomColor: 'transparent',
                borderBottomStyle: 'solid',
                ...(pathname?.endsWith(tab) ? { color: '#6C52A2', borderBottomWidth: '2px', borderBottomColor: '#6C52A2' } : { color: 'rgb(163, 175, 179)', cursor: 'pointer' }),
              }}
              to={`${ROUTES.SETTINGS}/${tab}`}
            >
              {TAB_KEYS_LABELS[tab]}
            </Link>
          ))}
        </div>
      </TabMenuContainer>
      <Container>
        <Switch>
          <Route path={`${ROUTES.SETTINGS}/${TAB_KEYS.CATEGORIES}`} exact>
            <Categories
              data={userCategories}
              selectedData={localCategories}
              onChange={handleCategoryChange}
            />
          </Route>
          <Route path={`${ROUTES.SETTINGS}/${TAB_KEYS.GENERAL}`} exact>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}
            >
              <Info
                onLogout={handleLogout}
                name={user.name}
                surname={user.surname}
                email={user.email}
              />
              {
                user ? (
                  <MembershipType user={user} type={user?.subscription_status_android || user?.subscription_status} />
                ) : null
              }
              <About user={user} version={version} itemCount={user.itemCount} syncVersion={user?.data_version} />
            </div>
          </Route>
          <Route path={`${ROUTES.SETTINGS}/${TAB_KEYS.TERMS}`} exact>
            <TermsAndConditions />
          </Route>
          <Route path={`${ROUTES.SETTINGS}/${TAB_KEYS.PRIVACY_POLICY}`} exact>
            <PrivacyPolicy />
          </Route>
          <Route path="*">
            <Redirect to={`${ROUTES.SETTINGS}/${TAB_KEYS.GENERAL}`} />
          </Route>
        </Switch>
      </Container>
    </div>
  );
}

export default withNavigationFilters(Settings);
